







module.exports =
  name: 'display_options'
  mounted: ->
    @$store.state.ui.transactions.calendar.event_title = localStorage.getItem('calendar_event_title')
    @$store.state.ui.transactions.calendar.event_title ||= 'event_title_short'
  computed:
    event_title:
      get: -> @$store.state.ui.transactions.calendar.event_title
      set: (val) ->
        localStorage.setItem('calendar_event_title', val)
        @$store.state.ui.transactions.calendar.event_title = val
